import { render } from "./TextBlock.vue?vue&type=template&id=27629222&scoped=true"
import script from "./TextBlock.vue?vue&type=script&lang=js"
export * from "./TextBlock.vue?vue&type=script&lang=js"

import "./TextBlock.vue?vue&type=style&index=0&id=27629222&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27629222"]])

export default __exports__